import { useState } from '@wordpress/element';

const InlineLoginForm = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleLoginSubmit = async (e) => {
        e.preventDefault();
        if(!username || !password) {
            setErrorMsg('Please enter both your username and password.');
            return;
        }

        setIsSubmitting(true);
        setErrorMsg('');

        // Dynamically resolve target base path safely using localized variables if available
        const rootUrl = window.ammData?.rootUrl || '/';
        const loginUrl = rootUrl.split('/wp-json/')[0] + '/wp-login.php';

        const formData = new FormData();
        formData.append('log', username);
        formData.append('pwd', password);
        formData.append('wp-submit', 'Log In');
        formData.append('redirect_to', window.location.href);

        try {
            // Background authenticate attempt to verify validity
            const response = await fetch(loginUrl, {
                method: 'POST',
                body: formData,
                redirect: 'manual' // Prevents the browser from auto-following the redirect chain
            });

            // A normal successful WP-Login POST response returns a redirect string (status 0 or 302)
            // If the user lands back on wp-login.php with an error string inside it, login failed.
            if(response.type === 'opaqueredirect' || response.status === 302 || response.url?.includes('redirect_to')) {
                // Success! Force reload the page context to trigger ammData updates
                window.location.reload();
            } else {
                // If it evaluated as a regular 200 stream, it didn't pass authentication
                setErrorMsg('Invalid login credentials. Please check your username and password.');
                setIsSubmitting(false);
            }
        } catch(err) {
            // Fallback strategy: If async fetch is blocked, attempt standard dynamic programmatic layout form POST submission
            const loginForm = document.createElement('form');
            loginForm.method = 'POST';
            loginForm.action = loginUrl;

            for(const [key, value] of formData.entries()) {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = key;
                input.value = value;
                loginForm.appendChild(input);
            }

            document.body.appendChild(loginForm);
            loginForm.submit();
        }
    };

    return (
        <div className="card shadow-sm border border-secondary rounded-3 mx-auto my-4 p-4" style={ { maxWidth: '450px' } }>
            <div className="text-center mb-4">
                <i className="fas fa-lock text-primary fa-2x mb-2"></i>
                <h4 className="fw-bold text-dark">Portal Sign In Required</h4>
                <p className="text-muted small">You must be signed in to manage your team's athletes and submit meeting entry declarations.</p>
            </div>

            { errorMsg && <div className="alert alert-danger py-2 small fw-semibold text-center mb-3">{ errorMsg }</div> }

            <form onSubmit={ handleLoginSubmit }>
                <div className="mb-3">
                    <label className="form-label small fw-bold text-secondary">Username or Email Address</label>
                    <input
                        type="text"
                        className="form-control shadow-sm"
                        value={ username }
                        onChange={ (e) => setUsername(e.target.value) }
                        disabled={ isSubmitting }
                        required
                    />
                </div>
                <div className="mb-3">
                    <label className="form-label small fw-bold text-secondary">Password</label>
                    <input
                        type="password"
                        className="form-control shadow-sm"
                        value={ password }
                        onChange={ (e) => setPassword(e.target.value) }
                        disabled={ isSubmitting }
                        required
                    />
                </div>
                <button type="submit" className="btn btn-primary w-100 fw-bold rounded-3 shadow-sm mt-2" disabled={ isSubmitting }>
                    { isSubmitting ? (
                        <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Verifying Identity...
                        </>
                    ) : 'Sign In & Access Entries Workspace' }
                </button>
            </form>
        </div>
    );
};

export default InlineLoginForm;